import { MainserviceService } from './mainservice.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { LoadingModule } from 'ngx-loading';
import { FlashMessagesModule } from 'ngx-flash-messages';
import { FilterPipeModule } from "ngx-filter-pipe";
import { OrderModule } from "ngx-order-pipe";
import { NgxPaginationModule } from "ngx-pagination";

import { AppRoutingModule } from './app.routing';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FooterModule } from './shared/footer/footer.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { LbdModule } from './lbd/lbd.module';

import { AuthGuardService } from "./services/auth-guard.service";
import { AuthService } from "./services/auth.service";

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { TablesComponent } from './tables/tables.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { MallsComponent } from './malls/malls.component';
import { GamesComponent } from './games/games.component';
import { UsersComponent } from './users/users.component';
import { CurrencyPipe } from './currency.pipe';
import { ShopsComponent } from './shops/shops.component';
import { PromocodesComponent } from './promocodes/promocodes.component';
import { ShopProfileComponent } from './shop/shop-profile/shop-profile.component';
import { ShopPromocodesComponent } from './shop/shop-promocodes/shop-promocodes.component';
import { LoginComponent } from './login/login.component';
import { MallProfileComponent } from './mall/mall-profile/mall-profile.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { GameDetailComponent } from './game-detail/game-detail.component';
import { ShopDetailComponent } from './shop-detail/shop-detail.component';
import { MallDetailComponent } from './mall-detail/mall-detail.component';

import { AddshopComponent } from './shops/addshop/addshop.component';
import { AddmallComponent } from './malls/addmall/addmall.component';
import { MallShopsComponent } from './mall-shops/mall-shops.component';
import { MallShopDetailComponent } from './mall-shop-detail/mall-shop-detail.component';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    UserComponent,
    TablesComponent,
    TypographyComponent,
    IconsComponent,
    MapsComponent,
    NotificationsComponent,
    UpgradeComponent,
    MallsComponent,
    GamesComponent,
    UsersComponent,
    CurrencyPipe,
    ShopsComponent,
    PromocodesComponent,
    ShopProfileComponent,
    ShopPromocodesComponent,
    LoginComponent,
    MallProfileComponent,
    WelcomeComponent,
    GameDetailComponent,
    ShopDetailComponent,
    MallDetailComponent,
    AddshopComponent,
    AddmallComponent,
    MallShopsComponent,
    MallShopDetailComponent

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NavbarModule,
    FooterModule,
    SidebarModule,
    RouterModule,
    AppRoutingModule,
    LbdModule,
    LoadingModule,
    FlashMessagesModule,
    FilterPipeModule,
    NgxPaginationModule,
    OrderModule
  ],
  providers: [MainserviceService, AuthService, AuthGuardService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/app.module.ts